import { analyticsUtils } from 'utils/analytics-utils';
import { SelectionGroupValue } from 'fronton-react/selection-group/types';

/**
 * Событие должно срабатывать при клике на чипсу материала.
 */

export const gaClickOnMaterial = ({
  surfaceName,
  materialName,
}: {
  surfaceName: string;
  materialName: SelectionGroupValue;
}) =>
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: 'productDetail / calc', // блок, в котором расположен элемент
    elementName: 'Какие поверхности вас интересуют?',
    elementText: `${surfaceName} / ${materialName}`, // название пункта / название подпункта
  });
